import { PageHeader } from "@/components/PageHeader";
import { EpidemicDashboard } from "@/components/epidemic/EpidemicDashboard";

export default function Epidemics() {
  return (
    <div className="space-y-8" data-testid="epidemics-page">
      <PageHeader title="Épidémies" subtitle="Cas épidémiologiques remontés par l'application Sehatic-Pedia, par âge, lieu et pathologie." />
      <EpidemicDashboard />
    </div>
  );
}
